import memberDetailsReportTypes from './member-details-report.type';

/** ***************** FETCH MEMBER DETAILS REPORT START *********************** */
export const fetchMemberDetailsReportStart = (addData: any) => ({
	type: memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_START,
	payload: addData,
});

export const fetchMemberDetailsReportSuccess = (successData: any) => ({
	type: memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_SUCCESS,
	payload: successData,
});

export const fetchMemberDetailsReportFailure = (failureData: any) => ({
	type: memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_FAILURE,
	payload: failureData,
});

export const fetchMemberDetailsReportResponseResetStart = () => ({
	type: memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_RESPONSE_RESET_START,
});

export const fetchMemberDetailsReportResponseResetChanged = () => ({
	type: memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER DETAILS REPORT END *********************** */
